import React, { FunctionComponent, useEffect, useState } from 'react';
import { filtersUsersState } from 'utils/states';
import WhiteCard from 'global/atoms/WhiteCard';
import Pagination from 'global/pagination/Pagination';
import Filters from 'global/filters/Filters';
import CountriesConnection from 'utils/connections/countries';
import Input from 'global/atoms/Input';
import { useHistory } from 'react-router-dom';
import { Cell, Column, HeaderCell } from 'rsuite-table';
import arrow from 'assets/svg/arrow_down_small.svg';
import settings from 'assets/svg/settings.svg';
import List from 'global/table/List';
import { useDispatch } from 'react-redux';
import Spinner from 'global/atoms/Spinner/Spinner';

interface ICountriesList {}

const CountriesList: FunctionComponent<ICountriesList> = () => {
  const [data, setData] = useState<any | null>(null);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState<any>({
    name: '',
    code: '',
    requestOrder: {
      field: '',
      order: '',
    },
    requestPaginate: {
      page: 1,
      limit: 10,
    },
  });
  const [toggleFilters, setToggleFilters] = useState<boolean>(false);
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    CountriesConnection.getCountries(filters).then((data) => {
      setLoading(false);
      setData(data.data);
      data.data?.header && dispatch({ type: 'SET_HEADER', payload: data.data.header });
    });

    setFilters((state: any) => ({
      ...state,
      requestPaginate: {
        page: 1,
        limit: state.requestPaginate.limit,
      },
    }));
  }, [filters.requestPaginate.limit]);

  useEffect(() => {
    CountriesConnection.getCountries(filters).then((data) => {
      setLoading(false);
      setData(data.data);
      data.data?.header && dispatch({ type: 'SET_HEADER', payload: data.data.header });
    });
  }, [filters.requestPaginate.page, filters.requestOrder]);

  const handleToggleSort = (event: any) => {
      if (filters.requestOrder.field === event.currentTarget.dataset.field) {
        setFilters({
          ...filters,
          requestOrder: {
            field: filters.requestOrder.field,
            order: filters.requestOrder.order === 'asc' ? 'desc' : 'asc',
          },
        });
      } else {
        setFilters({
          ...filters,
          requestOrder: {
            field: event.currentTarget.dataset.field,
            order: 'asc',
          },
        });
      }
    },
    handleToggleFilters = () => {
      setToggleFilters((state: boolean) => !state);
    },
    handleSubmitFilters = (event: any) => {
      event.preventDefault();

      CountriesConnection.getCountries({
        ...filters,
        requestPaginate: { page: 1, limit: filters.requestPaginate.limit },
      }).then((data) => {
        setLoading(false);
        setToggleFilters(false);
        setData(data.data);
        data.data?.header && dispatch({ type: 'SET_HEADER', payload: data.data.header });
        setFilters((state: any) => ({
          ...state,
          requestPaginate: { page: 1, limit: state.requestPaginate.limit },
        }));
      });
    },
    handleClearFilters = () => {
      setFilters((state: any) => ({
        ...state,
        ...filtersUsersState,
      }));
    },
    handleEdit = (event: any) => {
      history.push(`/superadmin/countries/${event.currentTarget.dataset.id}/edit`);
    };

  useEffect(() => {
    dispatch({ type: 'SET_FILTER', payload: handleToggleFilters });
  }, [handleToggleFilters]);

  if (loading) return <Spinner />;
  if (data === null) return null;

  return (
    <>
      <WhiteCard mobileTransparent={true} padding={false}>
        <List data={data.data} count={data.data.length}>
          <Column flexGrow={1} align="left">
            <HeaderCell depth={0} width={0}>
              <span
                style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                onClick={handleToggleSort}
                data-field={'name'}
              >
                Nazwa
                {filters.requestOrder.field === 'name' &&
                  (filters.requestOrder.order === 'asc' ? (
                    <img src={arrow} alt={'sort'} />
                  ) : (
                    <img src={arrow} alt={'sort'} style={{ transform: 'rotate(180deg)' }} />
                  ))}
              </span>
            </HeaderCell>
            <Cell width={100} depth={0} dataKey="name" />
          </Column>
          <Column verticalAlign={'middle'} align="right" fixed={'right'}>
            <HeaderCell depth={0} width={0}>
              Akcje
            </HeaderCell>
            <Cell depth={0} width={0}>
              {(rowData) => (
                <img
                  src={settings}
                  style={{ cursor: 'pointer' }}
                  alt={'Idź do'}
                  data-id={rowData.id}
                  onClick={handleEdit}
                />
              )}
            </Cell>
          </Column>
        </List>
      </WhiteCard>
      <Pagination
        count={data.count}
        page={filters.requestPaginate.page.toString()}
        limit={filters.requestPaginate.limit.toString()}
        setState={setFilters}
      />
      <Filters
        toggleFilters={toggleFilters}
        handleToggleFilters={handleToggleFilters}
        handleSubmit={handleSubmitFilters}
        handleClear={handleClearFilters}
      >
        <Input
          value={filters.name}
          placeholder={'Nazwa'}
          name={'name'}
          type={'text'}
          setState={setFilters}
          state={filters}
        />
        <Input
          value={filters.code}
          placeholder={'Kod'}
          name={'code'}
          type={'text'}
          setState={setFilters}
          state={filters}
        />
      </Filters>
    </>
  );
};

export default CountriesList;
